// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2ufjf","actionsCol":"EnrolledClinics_actionsCol__2xHT_"};